import React, { useState, useEffect, useRef } from "react"
import {useLoaderData, useParams} from "react-router-dom"
import api from "../../api/axiosConfig";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default function PDFfile () {

    const pdfRef = useRef();
    const FormData = require('form-data')
    const formData = new FormData()

    const {key, employeeEmail, month, year} = useParams();
    const timesheetDetails = useLoaderData()
    const timesheets = timesheetDetails.sheets
    const photos = timesheetDetails.photos
    const tok = timesheetDetails.token
    console.log(timesheetDetails.token)
    var  isApproved = false;

    if(tok.response==="approved"){
      isApproved = true;
    }
    var publicHolidays = timesheets.filter(x => x.dayType === 'Public Holiday');
    var totalHolidays = publicHolidays.length;
    console.log(publicHolidays, totalHolidays);
  
    var annualLeaves = timesheets.filter(x => x.dayType === 'Annual Leave');
    var totalLeaves = annualLeaves.length;
    console.log(annualLeaves, totalLeaves);
    
    var sickLeaves = timesheets.filter(x => x.dayType === 'Sick Leave');
    var totalSicks = sickLeaves.length;
    console.log(sickLeaves, totalSicks);
    
    var approvedOvertime = timesheets.filter(x => x.hoursOvertime > 0);
    console.log(approvedOvertime);
    
    const allHoursWorked = timesheets.map(row => JSON.parse(row.hoursWorked));
    const allOvertimeHours = timesheets.map(row => JSON.parse(row.hoursOvertime));
  
    console.log(allOvertimeHours)
    var totalHoursWorked = 0;
      for (let i = 0; i < allHoursWorked.length; i++ ) {
        totalHoursWorked += allHoursWorked[i];
      }
  
    var totalOvertimeHours = 0;
      for (let i = 0; i < allOvertimeHours.length; i++ ) {
        totalOvertimeHours += allOvertimeHours[i];
      }
    const getEmployeeName = () => {
      const tempName = employeeEmail.substring(0, employeeEmail.indexOf("@")).replace(".", " ");
      const arr = tempName.split(" ")
      console.log(arr)
      for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      const employeeName = arr.join(" ");
      return employeeName
      }
        
        const time = new Date();
        time.setHours(8,  0);
      
        const hours = time.getHours();
        const minutes = ((time.getMinutes() < 10 ? '0': '')+time.getMinutes());
        const defaultTimeIN = `${hours}:${minutes}`;
      
        var timeIN = "";
      
        const setStartTime = (e) => {
          if(e>0){
          timeIN = defaultTimeIN;
          }else{
            timeIN = " "
          }
        }
      
        var timeOUT = "";
      
        const setStopTime = (e1, e2) => {
          if(e1>0){
          var exitHour = Number(e2) + Number(hours) + Number(9);
          timeOUT=`${exitHour}:${minutes}`;
          }else{
            timeOUT = " "
          }
        }
    
        const getPDF = async({user}) => {    
          try{      
              const response = await api.get('/request/'+ employeeEmail + "/" + month + "/" + year);
              var linkSource = `data:application/pdf;base64,${response.data}`;
              const downloadLink = document.createElement("a");
              const fileName = employeeEmail.substring(0, employeeEmail.indexOf("@")).toUpperCase().replace(".", " ")+"-"+month+"-"+year;
  
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
  
              }catch(err){
              console.log(err);
          }
      }
return(
    <div>
    <div className="approvalForm" ref={pdfRef}> 
    <div className="requestHeader"> 
    <h1 className="requestMonthDisplay">{ month } { year }</h1>     
    <h6 className="requestSender">{ employeeEmail }</h6> 
    <div className="wrapper">
      <h6 className="requestSender2">Employee Name: {getEmployeeName()}</h6>
      <h6 className="requestSender2">Client: {tok.client}</h6>
      <h6 className="requestSender2">Project: {tok.project}</h6>
      <h6 className="requestSender2">Location: {tok.clientLocation}</h6>
    </div>
    {/* load client/location/project here */}
    </div>  
    <input type="hidden" className="form-control" name="employeeEmail" value={employeeEmail}/>
    <table className="approvalTbl">
      <thead>
        <tr className="approvalHdr">
          <th>DATE</th>
          <th>DAY TYPE</th>
          <th>HOURS WORKED</th>
          <th>OVERTIME HOURS</th>
          <th>TIME IN</th>
          <th>TIME OUT</th>
        </tr>
      </thead>
      <tbody className="approvalBody">
        {
          timesheets.map((user, index) => {
            return <tr key={index}>
              <td>{user.date}</td>
              <td>{user.dayType}</td>
              <td>{user.hoursWorked}</td>
              <td>{user.hoursOvertime}</td>
              <td onLoad={setStartTime(user.hoursWorked)}>{timeIN}</td>
              <td onLoad={setStopTime(user.hoursWorked, user.hoursOvertime)}>{timeOUT}</td>
            </tr>
          })
        }
      </tbody>
    </table>
    <table className="page1footer">
      <tr> 
        <th className="totalHours">TOTAL HOURS WORKED: {totalHoursWorked}</th>
      </tr>
    </table>
    <div className="wrapper">
    <table className="dtlSummaryTbl">
      {/* <tr className="totalHours">TOTAL OVERTIME HOURS: {totalOvertimeHours}</tr>   */}
      <thead> 
      <tr className="dtlSummaryHdr" >
        <th>SUMMARY</th>
        <th>DATES</th> 
        <th>No of Work Days</th>  
      </tr>
      </thead>
      
      <tbody className="dtlSummaryBody">
      <tr>
        <td className="summColumn1">Public Holiday</td>
        <td>
          <table  className="dtlSummaryDates">
            <tbody>
            {
              publicHolidays.map((user, index) => {
                return <tr key={index} className="day">
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
      </td>
      <td>{totalHolidays}</td>
      </tr>
      </tbody>
      <tbody className="dtlSummaryBody">
      <tr>
        <td className="summColumn1">Annual Leave</td>
        <td className="dtlSummaryDates">
          <table>
            <tbody>
            {
              annualLeaves.map((user, index) => {
                return <tr key={index}>
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
        </td>
        <td>{totalLeaves}</td>
      </tr>
      </tbody>
      <tbody className="dtlSummaryBody">
      <tr>
        <td className="summColumn1">Sick Leave</td>
        <td>
          <table>
            <tbody className="dtlSummaryDates">
            {
              sickLeaves.map((user, index) => {
                return <tr key={index}>
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
      </td>
      <td>{totalSicks}</td>
      </tr>
      </tbody>
      <tbody className="dtlSummaryBody">
      <tr className="dtlSummaryHdr2" >
        <th></th>
        <th></th>
        <th>Total Hours</th>
      </tr>
      <tr>
        <td className="summColumn1">Approved Overtime</td>
        <td className="dtlSummaryDates">
          <table>
            <tbody>
            {
              approvedOvertime.map((user, index) => {
                return <tr key={index}>
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
        </td>
        <td>{totalOvertimeHours}</td>
      </tr>
      </tbody>
    </table>
    {isApproved&&
    <div className="wrapper">
      <h6 className="requestSender2">Approved By: {tok.managerName}</h6>
      <h6 className="requestSender2">Approver Email: {tok.managerEmail}</h6>
    </div>}
    </div> 
    </div>

    <div className="approvalPhotosContainer" id="Page2">
      {
        photos.map((index) =>    
          <div key={index}>          
          <img className='approvalPhotos' src={'data:image/png;base64,'+index} />
          </div>
        )
      }
    </div>
<div className="approvalFooter">
    <button className="downloadBTN"
    onClick={getPDF}
    >DownloadPDF</button>
</div>
</div>
)
};

export const approvedDetailsLoader = async ({params}) => {
  const {key, employeeEmail, month, year} = params
  const[sheets, photos, token] = await Promise.all([
    api.get('/sheets/' + employeeEmail + "/" + month + "/" + year).then( res => res.data),
    api.get('/photos/' + employeeEmail + "/" + month + "/" + year).then( res => res.data),
    api.get('/request/approved/' + employeeEmail + month + year).then( res => res.data)
  ]);
  return{sheets, photos, token};
}
